import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgArrowLight(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 11 8" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.629.667L10.827 4 7.629 7.333 6.74 6.69l2.1-2.188H.827V3.498H8.84l-2.1-2.189.888-.642z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('ArrowLight')(SvgArrowLight);
